var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-progressBar"},[_c('span',{style:({width: _vm.progress + '%'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }